import { FormikValues } from 'formik'
import { InputValue } from '@/checkout-instore-legacy/product/typings'
import * as yup from 'yup'
import { useIntl } from '@/checkout-instore-legacy/hooks/intl'
import { SubmitProps } from './AttachmentForm'

interface Props {
  inputValues: InputValue[] | undefined
  initialValues?: SubmitProps
  isRequired?: boolean
}

const useFormValues = ({ inputValues, initialValues, isRequired }: Props) => {
  const intl = useIntl()

  let formInitialValues = {}
  let schemaValidationError = {}

  if (inputValues) {
    formInitialValues = inputValues.reduce((accumulator, input) => {
      let inputValue = input.defaultValue ?? ''

      if (initialValues) {
        inputValue = initialValues.content[input.label]
      }

      accumulator[input.label] = inputValue
      return accumulator
    }, {} as FormikValues)

    schemaValidationError = yup.object().shape(
      isRequired
        ? inputValues.reduce((accumulator, input) => {
            accumulator[input.label] = yup.string().required(
              intl.formatMessage({
                id: 'attachments.modal.form.field-required',
              })
            )
            return accumulator
          }, {} as FormikValues)
        : {}
    )
  }

  return { formInitialValues, schemaValidationError }
}

export default useFormValues
